// extracted by mini-css-extract-plugin
module.exports = {"container":"_3npkX","timeSlot":"_3K0RL","duration":"EzNf8","title":"_2ciYB","location":"_1CRfs","tags":"_2pzzV"};